import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { RutValidator } from 'ng9-rut';
import * as moment from 'moment';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { AuthService } from 'src/app/services/auth.service';
import { NotaService } from 'src/app/services/nota.service';
import { Contact } from 'src/app/models/contact.model';
import { ValidadorFechasService } from 'src/app/services/formsvalidators/validadorfechas.service'

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements OnInit {
  progress = false;
  alertError = false;
  alertSucces = false;
  btnEnviar = false;
  PerfilForm: FormGroup;
  validarionsRut: any;
  Nacionalidades: any[];
  Regiones: any[];
  RegionesColegios: any[];
  Comunas: any[];
  Ciudades: any[];
  Paises: any[];
  Establecimientos: any[];
  AnhosEgresos: any[];

  idChile = '1b8b4414-1615-e511-80c5-00155dfd1662';

  constructor(private contactservice: ContactService, private fb: FormBuilder, rutValidator: RutValidator,
    private mantenedor: MantenedorService, private auths: AuthService, private notaservice: NotaService,
    private validadorFechasService: ValidadorFechasService) {
    this.validarionsRut = rutValidator;
    this.PerfilForm = this.fb.group({
      //SerialRut: ['', [Validators.required, Validators.maxLength(9), Validators.minLength(9)]], //OK1
      SerialRut: ['', [Validators.required, Validators.pattern(/^([0-9]{9})$|^([0-9]{3}\.[0-9]{3}\.[0-9]{3})$|^([A][0-9]{9})$/)]],
      Nombre: ['', [Validators.required, Validators.maxLength(60), Validators.minLength(3)]], //OK -
      Nombre2: ['', [Validators.maxLength(60), Validators.minLength(3)]], //OK -
      ApellidoP: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]], //OK -
      ApellidoM: ['', [Validators.maxLength(50), Validators.minLength(3)]], //OK -
      Rut: ['', [Validators.required, Validators.maxLength(50), this.validarionsRut, Validators.minLength(3)]], //OK -
      Passaporte: [''],
      CorreoElectronico: ['', [Validators.email, Validators.required]], //OK -
      //Telefono: ['', [Validators.maxLength(9), Validators.minLength(9)]], //OK -
      Telefono: ['', [Validators.pattern(/^([(]{1}[2]{1}[)]{1}\s[0-9]{8})$/)]],
      Celular: ['', [Validators.required, Validators.maxLength(9), Validators.minLength(8)]], //OK -
      TipoDocumentos: ['1'], //OK -
      Nacionalidad: ['', Validators.required], //OK -
      FechaNacimiento: ['', [Validators.required, this.ValidarFecha, this.validadorFechasService.EntreAños(17, 71)]], //OK -
      Region: ['', Validators.required], //OK -
      Comuna: ['', Validators.required], //OK -
      Ciudad: ['', Validators.required], //OK -
      Calle: ['', Validators.required], //OK -
      CalleNro: [''], //OK -
      CalleDpto: [''], //OK -
      Banco: [''], //OK -
      TipoDeCuenta: [''], //OK -
      NroDeCuenta: [''], //OK -
      PresentaDiscapacidad: ['', Validators.required], //OK -
      Genero: ['', Validators.required], //OK
      EstadoCivil: ['', Validators.required], //OK
      EnsenhazaMediaEextranjero: [false], //OK
      PrimeroMedioExterior: [false], //OK
      SegundoMedioExterior: [false], //OK
      TerceroMedioExterior: [false], //OK
      CuartoMedioExterior: [false], //OK
      CuarsandoCuartoMedio: [''],
      CurseEnsenhanzaModalidad: [false], //OK // NO SE USA
      AnhoEgresoEM: [''], //OK
      RegionEstudio: [''], //OK
      EstablecimientoEducacionl: [''], //OK
      TipoDependencia: [''],
      CursoEM2x1: [false], //OK
      PrimeroMedio2x1: [false], //OK
      SegundoMedio2x1: [false], //OK
      TerceroMedio2x1: [false], //OK
      CuartoMedio2x1: [false], //OK
      DeseaRecibirAsesoria: [false], //OK
      Etnia: ['', Validators.required], //OK
      Pais: [this.idChile, Validators.required], //OK
      CertificadoCulminacionEM: [false], //OK
      IdContacto: [''], //OK
      BloqueoFinanciero: [false], //OK
      NotaPrimeroMedio: [],
      NotaSegundoMedio: [],
      NotaTerceroMedio: [],
      NotaCuartoMedio: [],
      PuntajePromedioPsu: [],
      Ranking: [],
      AnhoPsu: []
    });

    var user = this.auths.GetUserToken();
    if (user !== null) {
      this.contactservice.GetContactFull(user.primarysid, '').subscribe(
        (data: Contact) => {
          this.PerfilForm.controls['Nombre'].setValue(data.Nombre);
          this.PerfilForm.controls['Nombre2'].setValue(data.Nombre2);
          this.PerfilForm.controls['ApellidoP'].setValue(data.ApellidoP);
          this.PerfilForm.controls['ApellidoM'].setValue(data.ApellidoM);
          this.PerfilForm.controls['Rut'].setValue(data.Rut);
          if (this.PerfilForm.controls.Rut.value != null && this.PerfilForm.controls.Rut.value != '') {
            this.PerfilForm.controls.Rut.disable();
          } else {
            this.PerfilForm.controls.Rut.enable();
          }
          this.PerfilForm.controls['CorreoElectronico'].setValue(data.CorreoElectronico);
          if (data.Telefono && data.Telefono.trim().length > 0)
            this.PerfilForm.controls['Telefono'].setValue(this.formatearTelefonoBD(data.Telefono, true));
          this.PerfilForm.controls['Celular'].setValue(data.Celular);
          this.PerfilForm.controls['Calle'].setValue(data.Calle);
          this.PerfilForm.controls['CalleNro'].setValue(data.CalleNro);
          this.PerfilForm.controls['CalleDpto'].setValue(data.CalleDpto);
          this.PerfilForm.controls['Banco'].setValue(data.Banco);
          this.PerfilForm.controls['TipoDeCuenta'].setValue(data.TipoDeCuenta);
          this.PerfilForm.controls['NroDeCuenta'].setValue(data.NroDeCuenta);
          this.PerfilForm.controls['IdContacto'].setValue(data.IdContacto);
          this.PerfilForm.controls['SerialRut'].setValue(this.formatearSerieRutBD(data.SerialRut));
          if (this.PerfilForm.controls.SerialRut.value != null && this.PerfilForm.controls.SerialRut.value != '') {
            this.PerfilForm.controls.SerialRut.disable();
          } else {
            this.PerfilForm.controls.SerialRut.enable();
          }
          this.PerfilForm.controls['FechaNacimiento'].setValue(moment(data.FechaNacimiento, 'MM-DD-YYYY').format('YYYY-MM-DD'));
          //Boolean
          this.PerfilForm.controls['DeseaRecibirAsesoria'].setValue(data.DeseaRecibirAsesoria);
          this.PerfilForm.controls['EnsenhazaMediaEextranjero'].setValue(data.EnsenhazaMediaEextranjero);
          this.PerfilForm.controls['PrimeroMedioExterior'].setValue(data.PrimeroMedioExterior);
          this.PerfilForm.controls['SegundoMedioExterior'].setValue(data.SegundoMedioExterior);
          this.PerfilForm.controls['TerceroMedioExterior'].setValue(data.TerceroMedioExterior);
          this.PerfilForm.controls['CuartoMedioExterior'].setValue(data.CuartoMedioExterior);
          this.PerfilForm.controls['CursoEM2x1'].setValue(data.CursoEM2x1);
          this.PerfilForm.controls['BloqueoFinanciero'].setValue(data.BloqueoFinanciero);
          this.PerfilForm.controls['CurseEnsenhanzaModalidad'].setValue(data.CurseEnsenhanzaModalidad); // NO SE USA
          this.PerfilForm.controls['PrimeroMedio2x1'].setValue(data.PrimeroMedio2x1);
          this.PerfilForm.controls['SegundoMedio2x1'].setValue(data.SegundoMedio2x1);
          this.PerfilForm.controls['TerceroMedio2x1'].setValue(data.TerceroMedio2x1);
          this.PerfilForm.controls['CuartoMedio2x1'].setValue(data.CuartoMedio2x1);
          this.PerfilForm.controls['CertificadoCulminacionEM'].setValue(data.CertificadoCulminacionEM);
          //OptionSet
          this.PerfilForm.controls['Etnia'].setValue(data.Etnia?.Value);
          this.PerfilForm.controls['Genero'].setValue(data.Genero?.Value);
          this.PerfilForm.controls['EstadoCivil'].setValue(data.EstadoCivil?.Value);
          this.PerfilForm.controls['TipoDocumentos'].setValue(data.TipoDocumentos?.Value);
          this.PerfilForm.controls['Nacionalidad'].setValue(data.Nacionalidad?.Value);
          this.PerfilForm.controls['PresentaDiscapacidad'].setValue(data.PresentaDiscapacidad?.Value);
          //number
          this.mantenedor.getAnhoEgreso().subscribe(
            (datae: any) => {
              this.AnhosEgresos = datae.Result;
              if (data.AnhoEgresoEM !== null) {
                this.PerfilForm.controls['AnhoEgresoEM'].setValue(data.AnhoEgresoEM.Value);
              }

            },
            (err) => {
              // This is intentional
            },
            () => {
              // This is intentional
            }
          );

          //Lookups
          this.mantenedor.getPais().subscribe(
            (datax: any) => {
              this.Paises = datax.Result;
              console.log('[PERFIL]', data);
              if (data.Pais !== null) {
                this.PerfilForm.controls['Pais'].setValue(data.Pais.Id);
              } else {
                this.PerfilForm.controls['Pais'].setValue(this.idChile);
              }
            },
            (error) => {
              // This is intentional
            },
            () => {
              // This is intentional
            }
          );
          this.mantenedor.getRegion().subscribe(
            (datax: any) => {
              this.Regiones = datax.Result;
              this.RegionesColegios = datax.Result;
              if (data.RegionEstudio !== null) {
                this.PerfilForm.controls["RegionEstudio"].setValue(data.RegionEstudio.Id);
              }
              if (data.Region !== null) {
                this.PerfilForm.controls.Region.setValue(data?.Region?.Id);
                this.mantenedor.getCiudad(data.Region.Id).subscribe(
                  (datac: any) => {
                    this.Ciudades = datac.Result;
                    this.PerfilForm.controls['Ciudad'].setValue(data.Ciudad.Id);
                  }, (err) => console.log(err)
                );
                this.mantenedor.getComuna(data.Region.Id).subscribe(
                  (datar: any) => {
                    this.Comunas = datar.Result;
                    this.PerfilForm.controls['Comuna'].setValue(data.Comuna.Id);
                  }
                );

              }
            },
            (err) => {
              // This is intentional
            },
            () => {
              // This is intentional
            }
          );
        },
        (err) => { console.log(err) },
        () => {
          // This is intentional
        }
      );
    }
  }

  ngOnInit(): void {
    // This is intentional
  }

  ChangeNacionalidad(event: any) {
    const id = event.target.value;
    if (id === '1') {
      //chilena vlidar rut
      this.PerfilForm.controls.Rut.setValidators([
        Validators.required,
        Validators.maxLength(50),
        this.validarionsRut,
        Validators.minLength(3),
      ]);
      this.PerfilForm.controls.SerialRut.setValidators([
        Validators.required,
        Validators.pattern(
          /^([0-9]{9})$|^([0-9]{3}\.[0-9]{3}\.[0-9]{3})$|^([A][0-9]{9})$/
        ),
      ]);
      this.PerfilForm.controls.Rut.updateValueAndValidity();
      this.PerfilForm.controls.SerialRut.updateValueAndValidity();
      this.PerfilForm.controls.Passaporte.clearValidators();
      this.PerfilForm.controls.Passaporte.updateValueAndValidity();
    } else {
      this.PerfilForm.controls.Rut.clearValidators();
      this.PerfilForm.controls.SerialRut.clearValidators();
      this.PerfilForm.controls.Rut.updateValueAndValidity();
      this.PerfilForm.controls.SerialRut.updateValueAndValidity();
      this.PerfilForm.controls.Passaporte.setValidators([Validators.required]);
      this.PerfilForm.controls.Passaporte.updateValueAndValidity();
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  ValidarFecha(control: FormControl): { [s: string]: boolean } {
    const fechaActual = moment().format('YYYY-MM-DD');
    if (control.value >= fechaActual) {
      return {
        novalido: false
      };
    }
    return null;
  }

  ChangeRegion(event: any) {
    const id = event.target.value;
    if (id === '') { return; }
    this.mantenedor.getCiudad(id).subscribe(
      (data: any) => { this.Ciudades = data.Result; },
      error => { console.log('Error: ', error); }
    );
    this.mantenedor.getComuna(id).subscribe(
      (data: any) => { this.Comunas = data.Result; },
      error => { console.log('Error: ', error); }
    );
  }

  ChangeRegionColegio(event: any) {
    const id = event.target.value;
    if (id === '') { return; }
    this.mantenedor.getestablecimientoeducacionl(id).subscribe(
      (data: any) => { this.Establecimientos = data.Result; },
      error => { console.log('Error: ', error); }
    );
  }

  FieldsChange(values: any) {
    if (values.currentTarget.checked) {
      this.PerfilForm.controls.DeseaRecibirAsesoria.setValue(true);
      console.log(this.PerfilForm.controls.DeseaRecibirAsesoria.value)
    } else {
      this.PerfilForm.controls.DeseaRecibirAsesoria.setValue(false);
      console.log(this.PerfilForm.controls.DeseaRecibirAsesoria.value);
    }
  }

  formatearTelefono(formato: boolean) {
    var largo = this.PerfilForm.controls.Telefono.value.length;
    var data = this.PerfilForm.controls.Telefono.value;
    if (formato) {
      this.PerfilForm.controls.Telefono.setValue("2" + data.slice(4, 12));
    }
    else if (largo == 1 && data[0] != "(" && !formato) {
      this.PerfilForm.controls.Telefono.setValue("(2) " + data);
    }
  }

  formatearTelefonoBD(num: string, bd: boolean) {
    if (this.PerfilForm.controls.Telefono.value.length == 9 && !bd) {
      var data = this.PerfilForm.controls.Telefono.value;
      this.PerfilForm.controls.Telefono.setValue("(2) " + data.slice(1, 10));
    } else if (bd) {
      return "(2) " + num.slice(1, 10);
    }
  }

  formatearSerieRut() {
    var largo = this.PerfilForm.controls.SerialRut.value.length;
    var data = this.PerfilForm.controls.SerialRut.value;
    if (data[0] != "A" && largo == 9 && data[3] != "." && data[7] != ".") {
      data = data.slice(0, 3) + "." + data.slice(3, 6) + "." + data.slice(6, 9);
    }
    this.PerfilForm.controls.SerialRut.setValue(data);
  }

  formatearSerieRutBD(nom: string) {
    if (!nom)
      return nom;
    var data = nom;
    if (nom[0] != "A") {
      data = data.slice(0, 3) + "." + data.slice(3, 6) + "." + data.slice(6, 9);
    }
    return data;
  }

  formatearSerieRutSinPuntos() {
    if (this.PerfilForm.controls.SerialRut.valid) {
      var data = this.PerfilForm.controls.SerialRut.value;
      if (data[0] != "A") {
        data = data.slice(0, 3) + data.slice(4, 7) + data.slice(8, 11);
        this.PerfilForm.controls.SerialRut.setValue(data);
      }
    }
  }

  Actualizar() {
    this.validateAllFormFields(this.PerfilForm);
    if (this.PerfilForm.valid) {
      this.progress = true;
      this.formatearSerieRutSinPuntos();

      if (this.PerfilForm.controls["Telefono"].value.trim().length > 0)
        this.formatearTelefono(true);

      const contacto = new Contact(this.PerfilForm.value);
      this.contactservice.UpdateContact(contacto).subscribe(
        (data) => {
          this.alertSucces = true;
          setTimeout(() => {
            this.alertSucces = false;
            this.progress = false;
          }, 7000);
        },
        (err) => {
          this.alertError = true;
          setTimeout(() => {
            this.alertError = false;
            this.progress = false;

          }, 7000);
        },
        () => {
          this.progress = false;
        }
      );
      this.formatearSerieRut();
      this.formatearTelefonoBD(" ", false);
    } else {
      console.log(this.PerfilForm)
    }
  }
}
